import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  stepWrapper: _objectSpread({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    flexGrow: 1,
    overflow: 'auto !important'
  }, theme.utils.scrollbar),
  row: {
    display: 'flex',
    maxWidth: 600,
    alignItems: 'center',
    minHeight: 50,
    '& span': {
      color: theme.colors.utility.textPrimary
    }
  },
  rowIcon: {
    width: 32,
    height: 32,
    marginRight: 10
  },
  list: {
    margin: '10px 0 30px 0'
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 10,
    '& > div': {
      marginLeft: 10
    }
  },
  listItemIcon: {
    marginRight: 4,
    marginLeft: 10
  },
  title: {
    color: theme.colors.primary.black
  },
  boxes: {
    display: 'flex',
    justifyContent: 'center',
    '& $box:nth-child(1)': {
      marginRight: 10
    }
  },
  box: {
    display: 'flex',
    width: 315,
    minHeight: 95,
    padding: '15px 15px 15px 10px',
    boxSizing: 'border-box',
    border: `1px solid ${theme.colors.grey[100]}`,
    borderRadius: '8px',
    cursor: 'pointer',
    '& > div:nth-child(2)': {
      marginLeft: 10
    },
    '&:hover': {
      backgroundColor: 'rgba(211, 227, 254, 0.25)'
    }
  },
  topBox: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  boxIcon: {},
  file: {
    display: 'inline-block'
  },
  fileContainer: {
    display: 'flex',
    width: 'auto',
    marginTop: 20,
    padding: '3px 20px 3px 10px',
    alignItems: 'center',
    backgroundColor: theme.colors.actionMinor[50],
    border: '1px solid',
    borderColor: theme.colors.grey[100],
    borderRadius: '6px'
  },
  excelIcon: {
    display: 'flex',
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: 18,
      height: 18
    }
  },
  fileName: {
    margin: '0 10px 0 0'
  },
  matchFieldsList: {
    height: 'calc(100% - 8px - 8px) !important',
    boxSizing: 'border-box',
    margin: '8px 0px',
    border: `1px solid ${theme.colors.grey[100]}`,
    borderRadius: '6px',
    '& .ag-root': {
      border: 'none !important'
    },
    '& .ag-header-cell, & .ag-cell': {
      paddingLeft: '0 !important',
      '&::after': {
        border: 'none !important'
      }
    }
  },
  // Avoid duplicates
  duplicatesSubtitle: {
    marginTop: 20
  },
  duplicatesFieldsQuestion: {
    marginTop: 10
  },
  duplicatesQuestion: {
    marginTop: 20
  },
  duplicatesFieldButton: {
    marginLeft: 0
  },
  duplicatesFieldsItem: {
    marginLeft: 0
  },
  chooseId: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    // width: 352,
    backgroundColor: theme.colors.primary.white,
    borderRadius: 8,
    padding: '16px 16px 0'
  },
  chooseIdLabelContainer: {
    display: 'flex',
    marginBottom: 16,
    alignItems: 'center'
  },
  chooseIdLabelIconEdit: {
    marginRight: '8px'
  },
  chooseIdLabelIcon: {
    marginLeft: 4
  },
  chooseIdPopoverTitle: {
    marginBottom: 16
  },
  chooseIdAdvice: {
    marginBottom: 16
  },
  radioGroup: {
    padding: 0
  },
  multiplier: {
    marginBottom: 16
  },
  multiplierLoader: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 16
  },
  matchMandatory: {
    display: 'flex',
    padding: '20px'
  },
  matchMandatoryFieldTypes: {
    width: '40%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  matchMandatoryFieldTypesContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  matchMandatoryStandard: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  matchMandatoryExtra: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  matchMandatoryText: {
    marginRight: 8
  },
  modalInfoHeader: {
    display: 'flex',
    justifyContent: 'center'
  },
  modalInfoText: {
    textAlign: 'center',
    marginBottom: 16
  },
  modalInfoLink: {
    display: 'flex',
    justifyContent: 'center'
  },
  modalSuccess: {
    textAlign: 'center'
  },
  successFooter: {
    justifyContent: 'center !important'
  },
  importTypeBox: {
    maxWidth: 1000,
    '& > div': {
      minWidth: 900
    }
  }
});